var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcArb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H44V44H24C10.7452 44 0 33.2548 0 20V0Z",
    fill: "#0077E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.14062 15.5976V28.8647C8.14062 29.7118 8.59321 30.4951 9.3264 30.9172L20.8162 37.5522C21.5493 37.9743 22.4521 37.9743 23.1852 37.5522L34.675 30.9172C35.4082 30.4951 35.8608 29.7118 35.8608 28.8647V15.5976C35.8608 14.7505 35.4082 13.9672 34.675 13.5451L23.1852 6.9101C22.4521 6.48797 21.5493 6.48797 20.8162 6.9101L9.32363 13.5451C8.59044 13.9672 8.14062 14.7505 8.14062 15.5976Z",
    fill: "#213147"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5078 24.8044L22.8692 29.298C22.8249 29.4229 22.8249 29.5592 22.8692 29.6841L25.6881 37.416L28.9485 35.533L25.0352 24.8044C24.9463 24.5574 24.5964 24.5574 24.5075 24.8044H24.5078Z",
    fill: "#12AAFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7933 17.2473C27.7044 17.0002 27.3546 17.0002 27.2656 17.2473L25.627 21.7409C25.5827 21.8658 25.5827 22.0021 25.627 22.127L30.2455 34.7859L33.5059 32.903L27.793 17.2473H27.7933Z",
    fill: "#12AAFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9972 7.40734C22.0778 7.40734 22.1585 7.42949 22.2304 7.46857L34.6644 14.6478C34.8087 14.7312 34.8977 14.8866 34.8977 15.0506V29.4063C34.8977 29.5731 34.8087 29.7257 34.6644 29.809L22.2304 36.9883C22.1609 37.0298 22.0778 37.0495 21.9972 37.0495C21.9166 37.0495 21.836 37.0274 21.764 36.9883L9.33001 29.8146C9.18571 29.7312 9.09679 29.5758 9.09679 29.4118V15.0533C9.09679 14.8866 9.18571 14.734 9.33001 14.6506L21.764 7.47134C21.8363 7.4298 21.9166 7.40734 21.9972 7.40734ZM21.9972 5.31055C21.5557 5.31055 21.1111 5.42439 20.7142 5.65483L8.283 12.8313C7.48859 13.2894 7 14.1368 7 15.053V29.4088C7 30.3253 7.48889 31.1723 8.283 31.6305L20.717 38.8097C21.1142 39.0374 21.5557 39.154 22 39.154C22.4443 39.154 22.8861 39.0402 23.283 38.8097L35.717 31.6305C36.5114 31.1723 37 30.325 37 29.4088V15.053C37 14.1365 36.5111 13.2894 35.717 12.8313L23.2802 5.65483C22.883 5.42439 22.4387 5.31055 21.9972 5.31055Z",
    fill: "#9DCCED"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7734 34.8027L14.9177 31.6699L17.22 33.5833L15.0675 35.5497L13.7734 34.8027Z",
    fill: "#213147"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9525 14.0256H17.8004C17.5644 14.0256 17.3534 14.1727 17.2727 14.3951L10.5156 32.9195L13.776 34.8025L21.2165 14.4035C21.286 14.2201 21.1497 14.0256 20.9525 14.0256Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4653 14.0256H23.3132C23.0772 14.0256 22.8661 14.1727 22.7855 14.3951L15.0703 35.5471L18.3307 37.43L26.7293 14.4035C26.7961 14.2201 26.6598 14.0256 26.4653 14.0256Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArb);
export default __webpack_public_path__ + "static/media/icARB.afa21c01c9e102fbc8f239063f337d47.svg";
export { ForwardRef as ReactComponent };